module.exports = __webpack_public_path__ + "static/media/servicesBcg.dba99204.jpeg";